import { render, staticRenderFns } from "./addfunds.vue?vue&type=template&id=37e12426&"
import script from "./addfunds.vue?vue&type=script&lang=js&"
export * from "./addfunds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports